import './bootstrap'
import './idleDetect'

import {
  createApp,
  h
} from 'vue'
import {
  resolvePageComponent
} from 'laravel-vite-plugin/inertia-helpers'
import {
  createInertiaApp,
  Head,
  Link
} from '@inertiajs/inertia-vue3'
import {
  InertiaProgress
} from '@inertiajs/progress'
import {
  i18nVue
} from 'laravel-vue-i18n'
import HoneybadgerVue
  from '@honeybadger-io/vue'
import TextClamp
  from 'vue3-text-clamp'
import InlineSvg
  from 'vue-inline-svg'
import Vue3TouchEvents
  from 'vue3-touch-events'
import Datepicker
  from '@vuepic/vue-datepicker'
import dayjs
  from 'dayjs'
import dayJsPluginRelativeTime
  from 'dayjs/plugin/relativeTime'
import dayJsPluginUtc
  from 'dayjs/plugin/utc'
import dayJsPluginTimezone
  from 'dayjs/plugin/timezone'
import dayJsPluginAdvancedFormat
  from 'dayjs/plugin/advancedFormat'
import dayJsDuration
  from 'dayjs/plugin/duration'

import colors
  from '../../storage/appColors'

dayjs.extend(dayJsPluginRelativeTime)
dayjs.extend(dayJsPluginUtc)
dayjs.extend(dayJsPluginTimezone)
dayjs.extend(dayJsPluginAdvancedFormat)
dayjs.extend(dayJsDuration)

const appName = import.meta.env.VITE_APP_NAME || 'Classward'

const honeyBadgerConfig = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY, // 'hbp_7mANPLLRtbjAXBiQKN7Q8gZds2Ggl00la2nj',
  environment: process.env.NODE_ENV,
  revision: '1',
}

import.meta.glob(['../images/**', '../fonts/**'])

let app = createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue', { eager: false })
    ),
  setup ({
    el,
    app,
    props,
    plugin
  }) {
    let inertiaApp = createApp({ render: () => h(app, props) })

    inertiaApp.config.globalProperties.dayjs = dayjs
    inertiaApp.config.globalProperties.colors = colors

    inertiaApp
      .use(plugin)
      .use(HoneybadgerVue, honeyBadgerConfig)
      .use(TextClamp)
      .use(Vue3TouchEvents)
      .use(i18nVue, {
        resolve: async lang => {
          const langs = import.meta.glob('../../lang/*.json')
          return await langs[`../../lang/php_${lang}.json`]()
        }
      })
      .mixin({ methods: { route } })
      .mixin({
        methods: {
          getImageUrl (name, ext) {
            return new URL(`../images/${name}`, import.meta.url)
              .href
          },
        },
      })
      // third party components
      .component('inline-svg', InlineSvg)
      .component('Head', Head)
      .component('Link', Link)
      .component('Datepicker', Datepicker)

    inertiaApp.mount(el)

    return inertiaApp
  },
})

InertiaProgress.init({
  delay: 0,
  color: '#DD0000',
  includeCSS: true,
  showSpinner: true,
})
